var _defs, _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00ac71;}.cls-2{fill:none;stroke:#00ac71;stroke-linejoin:round;stroke-width:1.4px;}.cls-3{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.58434,11.66651h11.3845A1.53845,1.53845,0,0,1,22.50729,13.205V23.46126a1.53845,1.53845,0,0,1-1.53845,1.53845H9.58434A1.53845,1.53845,0,0,1,8.0459,23.46126V13.205A1.53844,1.53844,0,0,1,9.58434,11.66651Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.58434,11.66651h11.3845A1.53845,1.53845,0,0,1,22.50729,13.205V23.46126a1.53845,1.53845,0,0,1-1.53845,1.53845H9.58434A1.53845,1.53845,0,0,1,8.0459,23.46126V13.205A1.53844,1.53844,0,0,1,9.58434,11.66651Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.27668,11.6666v-3a3.84634,3.84634,0,0,0-4-3.66663,3.84634,3.84634,0,0,0-4,3.66663v3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 15.27649,
    cy: 18.33308,
    r: 1.76921
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLock);
export default __webpack_public_path__ + "static/media/ic_lock.8550bf26e1b42013a7ef5ab7635fc05a.svg";
export { ForwardRef as ReactComponent };